import { useCallback, useEffect } from 'react';

import { useAtom, useSetAtom } from 'jotai';

import { fetchPaymentAtom, refreshPaymentAtom } from 'data/payments/atoms';

export const useFetchPayment = (depositId: string) => {
  const [paymentRemote, executePaymentFetch] = useAtom(fetchPaymentAtom);

  const fetchPayment = useCallback(() => {
    if (depositId) executePaymentFetch(depositId);
  }, [depositId, executePaymentFetch]);

  useEffect(() => {
    fetchPayment();
  }, [fetchPayment]);

  return {
    paymentRemote,
    fetchPayment,
  };
};

export const usePollPayment = (depositId: string) => {
  const refreshPayment = useSetAtom(refreshPaymentAtom);

  const fetchPayment = useCallback(() => {
    if (depositId) refreshPayment(depositId);
  }, [depositId, refreshPayment]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchPayment();
    }, 10000);

    return () => clearInterval(interval);
  }, [fetchPayment]);
};
